import { create } from "zustand";
import { persist } from "zustand/middleware";

import { detectBrowserLanguage, isSupportedLanguage } from "../../../../utils/browser-language";

export const SupportedLanguages = {
  ENGLISH: "en",
  POLISH: "pl",
} as const;

export type Language = (typeof SupportedLanguages)[keyof typeof SupportedLanguages];

type LanguageStore = {
  language: Language;
  setLanguage: (lang: Language) => void;
  initializeLanguage: (applicationLang?: string | null) => Language;
};

function getDefaultLanguage(): Language {
  //return detectBrowserLanguage();
  return SupportedLanguages.ENGLISH;
}

export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set, get) => ({
      language: getDefaultLanguage(),
      setLanguage: (lang) => set({ language: lang }),
      initializeLanguage: (applicationLang) => {
        const currentState = get();

        if (applicationLang && isSupportedLanguage(applicationLang)) {
          set({ language: applicationLang });
          return applicationLang;
        }

        if (currentState.language && isSupportedLanguage(currentState.language)) {
          return currentState.language as Language;
        }

        //const browserLang = detectBrowserLanguage();
        //set({ language: browserLang });
        //return browserLang;
        //return currentState.language;

        // 3️⃣ HARD DEFAULT (admin default = EN)
        set({ language: SupportedLanguages.ENGLISH });
        return SupportedLanguages.ENGLISH;


      },
    }),
    {
      name: "language-storage",
    },
  ),
);
